import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message,
  ButtonOBSOLETED,
} from "../../web.common";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import withApi from "../higherOrderComponents/withApi";
import { DisplayGuid } from "../items";
import { DetailsRightBar, Divider, Action } from "./DetailsRightBar";

const AreaInternal = (props) => {
  const [areaData, setAreaData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const { match: { params: { areaId } } } = props;
  const { api: { areas: { getArea, deleteArea } } } = props;

  useEffect(() => {
    const loadArea = async () => {
      try {
        const area = await getArea(areaId);
        setAreaData(area);
      } catch (e) {
        setErrorMessage(new Message('error', 'Unable to get area data'));
      }
    };

    loadArea();
  }, [areaId, getArea]);

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this area? This action cannot be undone.')) {
      return;
    }

    try {
      await deleteArea(areaId);
      setErrorMessage(new Message('success', 'Area deleted successfully'));
      setTimeout(() => {
        props.history.push('/areas');
      }, 1500);
    } catch (e) {
      const message = e.response?.data?.message || 'Unable to delete area';
      setErrorMessage(new Message('error', message));
    }
  };

  const handleEdit = () => {
    props.history.push(`/area/${areaId}/edit`);
  };

  let mappedData = null;

  if (areaData) {
    const {
      areaId: id,
      name,
      slug,
      countryCode,
      position,
      zipFrom,
      zipTo,
      isMainArea,
      isSuperArea
    } = areaData;

    mappedData = {
      Id: <DisplayGuid>{id}</DisplayGuid>,
      Name: name,
      Slug: slug,
      'Country Code': countryCode || '-',
      'Is Main Area': isMainArea ? 'Yes' : 'No',
      'Is Super Area': isSuperArea ? 'Yes' : 'No',
      'Zip From': zipFrom || '-',
      'Zip To': zipTo || '-',
      'Latitude': position?.latitude ? position.latitude.toFixed(6) : '-',
      'Longitude': position?.longitude ? position.longitude.toFixed(6) : '-',
    };
  }

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={errorMessage} />

          <div className='content-with-right-pane-delimiter'>
            <PageTop
              documentTitle='Area details'
              documentDescription='Area details'
            />

            <h2 className='main-page-header main-page-header-with-subheader'>
              Area
            </h2>
            <h5 className='main-page-subheader'>{areaId}</h5>
            <br />

            {
              mappedData ? (
                <React.Fragment>
                  <DataDefinitionList
                    listData={mappedData}
                    classNames={['detail-page-list']}
                  />
                </React.Fragment>
              ) : <Loader hasLoaded={false}>Loading...</Loader>
            }
          </div>

          <DetailsRightBar>
            {
              mappedData ? (
                <React.Fragment>
                  <Divider>Actions</Divider>
                  <Action action={handleEdit}>
                    Edit Area
                  </Action>
                  <Action action={handleDelete}>
                    Delete Area
                  </Action>
                </React.Fragment>
              ) : ''
            }
          </DetailsRightBar>
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
};

AreaInternal.propTypes = {
  api: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  isLoggedIn: PropTypes.bool
};

const Area = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(AreaInternal)));

Area.requiresLogin = true;
Area.propTypes = { isLoggedIn: PropTypes.bool };

export default Area;
